'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useRatingContextValues", {
    enumerable: true,
    get: function() {
        return useRatingContextValues;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const useRatingContextValues = (ratingState)=>{
    const { color, hoveredValue, iconFilled, iconOutline, itemLabel, name, step, size, value } = ratingState;
    const ratingItem = _react.useMemo(()=>({
            color,
            hoveredValue,
            iconFilled,
            iconOutline,
            interactive: true,
            itemLabel,
            name,
            step,
            size,
            value
        }), [
        color,
        hoveredValue,
        iconFilled,
        iconOutline,
        itemLabel,
        name,
        step,
        size,
        value
    ]);
    return {
        ratingItem
    };
};
